import { render } from "./DemographicsInformation.vue?vue&type=template&id=411c86f9"
import script from "./DemographicsInformation.ts?vue&type=script&lang=js&external"
export * from "./DemographicsInformation.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__